<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记 </div>
    </div>
    <div class="auto padding250">
       <p class="title">证书信息登记</p>
      <div class="container ">
        <div class="formWrapper">
          <Form :label-width="80" label-position="right" class="formMin" >
            <FormItem label="姓名">
              <Input  value="" placeholder="请输入姓名"/>
            </FormItem>

            <FormItem label="身份证号 ">
              <Input  value="" placeholder="请输入身份证号"/>
            </FormItem>
            <FormItem label="证书名称 ">
              <Input  value="" placeholder="请输入证书名称"/>
            </FormItem>
            <FormItem label="证书编号  ">
              <Input  value="" placeholder="请输入证书编号"/>
            </FormItem>
            <FormItem label="颁证机构  ">
              <Input  value="" placeholder="请输入颁证机构"/>
            </FormItem>
            <FormItem label="颁证日期  ">

                <DatePicker class="dateRight" value="2018-09-06" type="date" placeholder="请选择日期" style="width: 244px;"></DatePicker>

            </FormItem>
            <FormItem label="颁证有效期   ">

                <DatePicker class="dateRight" value="2018-09-06" type="date" placeholder="请选择有效期" style="width: 244px;"></DatePicker>

            </FormItem>
            <FormItem label=" ">
              <router-link to="/zhengshu">下一步</router-link>
            </FormItem>
          </Form>
        </div>

      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.formWrapper{
    width: 330px;

  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/certificate/dengji.vue